import { Component } from '@angular/core';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent {

  
constructor(public ref: DynamicDialogRef, public config: DynamicDialogConfig) {}

  accept() {
    this.ref.close(true);
  }

  reject() {
    this.ref.close(false);
  }

  
}
